import React from 'react';
import { Avatar as MUIAvatar } from '@mui/material';
import { SxProps } from '@mui/system';
import { hash } from '@zonofi/common/functions/hash';
import { getNameInitials } from '@zonofi/common/functions/get-name-initials';

export interface AvatarProps {
  profileUrl?: string;
  id?: string;
  title?: string;
  style?: SxProps;
  size?: number;
  icon?: React.ReactNode;
  iconColor?: string;
  fontSize?: string;
  iconBgColor?: string;
}

const avatarRandomColors = [
  '#C8FAF9',
  '#E8D6FE',
  '#FEE2BE',
  '#E5F9B3',
  '#CDFAE4',
  '#F9D5FE',
  '#BEEBFC',
  '#FFDAEE',
  '#FDF7BC',
  '#DDDEFF',
  '#FFE1D9',
  '#E5EFFF',
];

export const Avatar: React.FC<AvatarProps> = ({
  profileUrl,
  id,
  title,
  style = {},
  size = 40,
  icon,
  iconColor = '#000',
  fontSize = '12px',
  iconBgColor,
}) => {
  const initials = getNameInitials(title || '') || '#';
  const backgroundColor =
    avatarRandomColors[hash(id || title, avatarRandomColors.length)];

  const mergedStyle: SxProps = {
    width: size,
    height: size,
    fontFamily: 'Segoe-UI-VF',
    ...style,
  };

  return profileUrl ? (
    <MUIAvatar src={profileUrl} sx={mergedStyle} />
  ) : icon ? (
    <MUIAvatar
      sx={{
        ...mergedStyle,
        backgroundColor: iconBgColor || 'transparent',
        color: iconColor,
      }}
    >
      {icon}
    </MUIAvatar>
  ) : (
    <MUIAvatar
      sx={{
        ...mergedStyle,
        bgcolor: backgroundColor,
        color: '#000',
        fontSize: fontSize,
        fontWeight: 500,
      }}
    >
      {initials}
    </MUIAvatar>
  );
};
